<template>
  <f7-page name="webkamery" @page:init="onPageInit" class="page-content">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Web kamery</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-block class="margin-top-half padding-half">
        <f7-row v-for="(p_webcams, i) in groupedWebcams" :key="i">
          <f7-col v-for="i_webcam in p_webcams" :key="i_webcam.id">
            <f7-card class="demo-facebook-card">
              <f7-card-header class="no-border no-padding no-margin justify-content-center wc-header">
                <div class="wc-name">{{ i_webcam.name }}</div>
              </f7-card-header>
              <f7-card-content :padding="false" class="justify-content-center text-align-center">
                <f7-link :href="'/webkamery/' + i_webcam.id">
                  <img class="lazy lazy-fade-in" :src="getLatestWebcamImage(i_webcam)"  width="100%">
                </f7-link>
              </f7-card-content>
              <f7-card-footer class="no-margin no-padding text-align-center justify-content-center wc-footer">
                <div class="wc-footer-stamp">{{ getLatestWebcamDt(i_webcam) }}</div>
              </f7-card-footer>
            </f7-card>
          </f7-col>
        </f7-row>
      </f7-block>


    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


export default {
  data: function () {
    return {
      webcamData: {},
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
    };
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  computed: {
    groupedWebcams() {
      return _.chunk(this.webcamData, 2);
    }
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getwebcams', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.webcamData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať webkamery', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },

    getLatestWebcamImage(webcam_data) {
        const self = this;
        let url = webcam_data.base_url;

       let latest = webcam_data.links.reduce((a, b) => {
        return new self.$moment(a.dt).unix() > self.$moment(b.dt).unix() ? a : b;
      })

      if (latest) {
        return url + latest.img;
      } else {
        return 'http://www.shmu.sk/img/blank.png';
      }


    },

    getLatestWebcamDt(webcam_data) {
      const self = this;
      let latest = webcam_data.links.reduce((a, b) => {
        return new self.$moment(a.dt).unix() > self.$moment(b.dt).unix() ? a : b;
      })

      if (latest) {
        return self.$moment(latest.dt).format('DD.MM.YYYY HH:mm');
      } else {
        return '?';
      }


    },
  }

};
</script>

<style lang="scss">

.wc-name {
  font-size: 0.7rem;
  padding: 0 0.25rem;
  font-weight:bold;
}
.wc-header {
  max-height: 38px;
  min-height: 38px;

}

.wc-footer {
  min-height: 38px;
}

.wc-footer-stamp {
  font-size: 0.7rem;
}

</style>
